/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/Nylon.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder016.geometry}
				material={materials["Satin Fabric"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder016_1.geometry}
				material={materials["Snooker Pool Table Cloth"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder016_2.geometry}
				material={materials["Neutral Woven Fabric"]}
			/>
		</group>
	);
}

useGLTF.preload("models/Nylon.glb");
